<template>
  <b-button
    :variant="disabled ? 'secondary' : 'primary'"
    class="add-button"
    :disabled="disabled"
  >
    <div class="d-flex align-items-center">
      <add-icon class="mr-1 add-banner-btn" />
      <span>{{ btnLabel }}</span>
    </div>
  </b-button>
</template>

<script>
  import { BButton } from 'bootstrap-vue';
  import AddIcon from '@/@core/components/svg/button/AddBanner.vue';

  export default {
    components: {
      BButton,
      AddIcon,
    },
    props: {
      btnLabel: { type: String },
      disabled: { type: Boolean, default: false },
    },
  };
</script>

<style scoped>
  .add-button {
    padding: 0.8rem 1rem;
    border-radius: 0.8rem;
    font-size: 18px;
  }

  .add-banner-btn {
    fill: var(--button-primary-font);
    width: 20px;
  }
</style>
